module.exports = __webpack_public_path__ + "img/undraw_missed_chances.e5233c59.webp";